//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { DialogEnums, StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { useArticleService } from "serviceHooks";

function useRemoveArticleDialog() {
  const articleService = useArticleService();

  const onDeleteArticle = (id: number) => {
    return articleService.deleteArticle(id);
  };

  const removeArticleDialog = (articleId: number, onSubmitSuccess?: () => void): DialogProps => {
    return {
      isOpen: false,
      id: "removeArticle",
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.RemoveArticleTitle),
      dialogType: DialogEnums.DialogType.Message,
      titleIcon: IconDefinitionConstants.WTrashAlt,
      type: StyleEnums.DisplayType.Danger,
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.RemoveArticleDescriptionText),
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Remove),
          successMessage: TranslationKeys.Article.RemoveArticleSuccess,
          type: StyleEnums.DisplayType.Danger,
          onClick: onDeleteArticle.bind(null, articleId),
        },
      ],
      onSubmit: onSubmitSuccess,
      maxWidth: "sm",
    };
  };

  return removeArticleDialog;
}

export default useRemoveArticleDialog;
